import { useState, useEffect, useRef } from 'react'
import { toast } from 'sonner'
import { useRestClient } from '@/contexts/QueryProvider'
import { useCurrentApplication } from '../useCurrentApplication'
import { Button } from '@/components/shadcn/button'
import { IconDownloadOutline } from '@icons/IconDownloadOutline'

export function SyncExportV3() {
  const [startDownload, setStartDownload] = useState<boolean>(false)
  const hasDownloadedRef = useRef(false)
  const { applicationId, appKey } = useCurrentApplication()
  const { getAppSettingsApiGetAppSettingsDownloadFile } = useRestClient()
  const { data, isFetching, isError } = getAppSettingsApiGetAppSettingsDownloadFile.useQuery(
    { path: { applicationId } },
    { enabled: startDownload }
  )

  useEffect(() => {
    if (data && startDownload && !hasDownloadedRef.current) {
      const filename = `dmpexport-${appKey || applicationId}-${new Date()
        .toISOString()
        .replace(/[^A-Za-z0-9_]+/g, '')
        .slice(0, -1)}.json`
      hasDownloadedRef.current = true
      const blob = new Blob([data as unknown as BlobPart], { type: 'application/octet-stream' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
      setStartDownload(false)
    }
  }, [appKey, applicationId, data, startDownload])

  // Reset the ref when startDownload becomes false (allows re-downloading)
  useEffect(() => {
    if (!startDownload) {
      hasDownloadedRef.current = false
    }
  }, [startDownload])

  useEffect(() => {
    if (isError) {
      toast.error('Error downloading file')
      setStartDownload(false)
    }
  }, [isError])

  return (
    // <div className="flex-1 self-stretch pb-1">
    <div className="flex-1 self-stretch">
      <Button
        variant="outline"
        className="h-full w-full flex-col gap-y-5 rounded-lg py-4"
        onClick={() => setStartDownload(true)}
        disabled={isFetching}
      >
        <IconDownloadOutline className="mr-2 size-7 text-foreground/20" />
        <span>Export current config to a JSON file</span>
      </Button>
    </div>
  )
}
